import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CevreTemizlikTarifeAPI extends BaseAPI {
    constructor() {
        const baseUrl = environment.API_URL + "CtvTarifeListe";
        super(baseUrl);
    }
    getCevreTemizlikVergisiTarifeleriListe(yili?: number, Grup?: number, Derece?: number) {
        return this.get("", { params: { yili: yili, grup: Grup, derece: Derece } });
    }
}

export default new CevreTemizlikTarifeAPI();